/**
 * Lazily load the icon component.
 *
 * @param iconName Name of the icon.
 * @param iconSize Size of the iconset.
 *
 * @returns The icon SVG component.
 */
export async function loadIconComponent(iconName, iconSize) {
    const iconset = await loadIconset(iconSize);
    const component = iconset[iconName];
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!component) {
        throw new Error(`Icon "${iconName}" from size "${iconSize}" was not found. Please check if the SVG file exists and regenerate icon components.`);
    }
    return component;
}
export async function loadIconset(iconSize) {
    const module = await loadIconsetModule(iconSize);
    return module.default;
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
async function loadIconsetModule(iconSize) {
    switch (iconSize) {
        case "XS":
            return await import(/* webpackChunkName: "iconset-S" */ "./generated/icons/S");
        case "S":
            return await import(/* webpackChunkName: "iconset-S" */ "./generated/icons/S");
        case "M":
            return await import(/* webpackChunkName: "iconset-M" */ "./generated/icons/M");
        case "L":
            return await import(/* webpackChunkName: "iconset-L" */ "./generated/icons/L");
        case "XL":
            return await import(/* webpackChunkName: "iconset-XL" */ "./generated/icons/XL");
        case "XXL":
            return await import(/* webpackChunkName: "iconset-XXL" */ "./generated/icons/XXL");
        case "MISC":
            return await import(/* webpackChunkName: "iconset-MISC" */ "./generated/icons/MISC");
    }
}
